import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardBasicComponent } from './card-basic.component';
import { IdsModule } from 'src/app/ids.module';

@NgModule({
  imports: [
    CommonModule, 
    IdsModule,
  ],
  declarations: [CardBasicComponent],
  exports: [CardBasicComponent]
})
export class CardBasicModule { }
